<template>
  <div class="py-3 borb hovek w-full">
    <div class="flex items-center cursor-pointer py-2">
      <div @click="handlecheckbox(item.phone)"></div>
      <img
        class="w-10 h-10 rounded-full mr-2"
        src="../../assets/images/avatar.png"
        alt="Avatar"
      />
      <div class="text-sm w-full">
        <div class="flex w-full items-center">
          <div class="w-5/12">
            <h6 class="fsize12 font-semibold mb-0 text-black" v-if="item.name">
              {{ item.name }}
            </h6>
            <p class="fsize10 font-semibold mb-0 text-black" v-if="item.phone">
              +{{ item.phone }}
            </p>
          </div>

          <div
            class="w-7/12 flex gap-1 items-center hovericons justify-between"
          >
            <!-- <p class="chat_user_time assignedClass fsize10 text-success">
              {{ CheckGetAssigned(item.phone) ? "Assigned" : "" }}
               <span v-if="this.userData.role === 'admin' && assignedTo">
                  to {{ assignedTo }}</span
                > 
            </p>
            <p class="chat_user_time assignedClass fsize10 text-warning">
              {{ CheckGetAssigned(item.phone) ? "" : "Not Assigned" }}
            </p> -->
            <div
              class="expired-dp flex gap-2 justify-center items-center w-7/12"
            >
              <p class="fsize10" :title="checkTime(item.phone)">
                <Sethours :status="checkhours(item.phone)" />
              </p>
              <!-- <div class="display-none">{{ checkhours(item.phone) }}</div> -->
              <p class="fsize10">
                <initials :status="checkinitial(item.phone)" />
              </p>
            </div>
            <!-- <el-dropdown class="dropdownw">
              <span class="el-dropdown-link flex justify-end fsize10 items-center">
                <status :status="statuss" />
                <small class="fsize10 font-semibold">
                  {{ checkCurrenttStatus(item.phone) }}</small><i
                  class="el-icon-arrow-down el-icon--right icons w-3 h-3"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="px-8" v-for="val in statusval"><small class="fsize10 font-semibold"
                    @click="updateChatStatus(item.phone, val)">{{ val }}</small></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <el-dropdown class="dropdownw border w-5/12 py-1 rounded-lg">
              <span
                class="el-dropdown-link flex justify-center fsize10 items-center"
              >
                <status :status="statuss" />
                <small class="fsize10 font-semibold">
                  {{ checkCurrenttStatus(item.phone) }}</small
                >
                <i class="el-icon-arrow-down el-icon--right w-3 h-3"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  class="px-8"
                  v-for="(val, index) in statusval"
                  :class="{ 'bg-primary text-white': val == statuss }"
                  :key="index"
                  ><p
                    class="fsize10 font-semibold w-full h-full"
                    @click="updateChatStatus(item.phone, val)"
                  >
                    {{ val }}
                  </p></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <!-- </el-checkbox> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import status from "./status";
import Sethours from "./Sethours";
import checkbox from "./checkbox";
import initials from "./initials";
export default {
  components: {
    status,
    Sethours,
    initials,
    checkbox,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      checkedall: false,
      initial: "",
      fullname: "",
      mutenotification: false,
      rmval: "",
      statuss: "",
      statusval: ["Open", "Pending", "Closed"],
      gethours: null,
      checked: ["918318096514"],
      arrmno: [],
    };
  },
  computed: {
    ...mapGetters("whatsappChat", {
      contacts: "contacts",
      activeChat: "activeChat",
      avatar: "avatar",
    }),
    ...mapState("admin", {
      login: "login",
    }),
    ...mapState("AgentRouting", {
      assignmono: "assignmono",
      rmrecord: "rmrecord",
      getassigned: "getassigned",
      assignStatus: "assignStatus",
      allassignagent: "allassignagent",
      checknumber: "checknumber",
      assignmono: "assignmono",
    }),
    ...mapState("auth", {
      userData: "userData",
    }),
    isActiveChat() {
      return this.item.phone == this.activeChat.phone;
    },
    isAssigned() {
      return this.assignedChats.findIndex(
        (x) => x.assignedNumber === this.item.phone
      ) !== -1
        ? true
        : false;
    },
    assignedTo() {
      const index = this.assignedChats.findIndex(
        (x) => x.assignedNumber === this.item.phone
      );
      return index !== -1
        ? this.assignedChats[index].assignedTo.firstname
        : false;
    },
    assignedClass() {
      return this.assignedChats.findIndex(
        (x) => x.assignedNumber === this.item.phone
      ) !== -1
        ? "text-success"
        : "text-warning";
    },
  },
  watch: {
    async contacts() {
      // await this.fetchContacts();
    },
  },
  methods: {
    async fetchContacts() {
      let payload = {};
      if (this.assignmono.length > 0) {
        Object.assign(payload, { number: this.assignmono[0].assignedNumber });
      }
      await this.$store.dispatch("whatsappChat/fetchContacts", payload);
    },
    async handlecheckboxssss(mno) {
      const arr = [];
      console.log(this.checknumber);

      // return console.log(this.checknumber, "mnoooooooooooo");
    },
    handlepopup(mno) {
      this.arrmno.push(mno);
      // console.log(this.arrmno, "this.arrmno");
    },
    checkinitial(phone) {
      for (let i = 0; i < this.allassignagent.length; i++) {
        console.log(this.allassignagent[i].result[0], "cccccccccccccccc");
        if (this.allassignagent[i].usermno == phone) {
          return this.allassignagent[i].result[0].name;
        }
      }
      // console.log("falseeeee");
      return "null";
    },
    checkhours(phone) {
      for (let i = 0; i < this.allassignagent.length; i++) {
        if (this.allassignagent[i].usermno == phone) {
          // console.log(this.allassignagent[i], "vvvvvvvvvvvvvvvvvvvvvvvvv");
          let curdate = new Date();
          let timediff = Math.abs(
            curdate.getTime() -
              new Date(this.allassignagent[i].updatedAt).getTime()
          );
          let hours = Math.floor(timediff / (1000 * 60 * 60));

          if (this.allassignagent[i].isreply == false) {
            return Number(24 - hours);
          } else {
            return "Assigned";
          }
        }
      }
      // console.log("falseeeee");
      return null;
      // var result=  this.allassignagent.filter((val) => {
      console.log(val, "valval");
      //  return val.usermno == phone
      // });
      // if(result.length>0){

      //   let curdate = new Date();
      //           let timediff = Math.abs(
      //             curdate.getTime() - new Date(result[0].updatedAt).getTime()
      //           );
      //           this.gethours = Math.floor(timediff / (1000 * 60 * 60));
      //             this.gethours=24-this.gethours
      //         console.log(this.gethours,"ppppppppppppppppppppppp")

      // }else{
      //     this.gethours="Not Assign"
      //   console.log("notr assign")

      // }
    },
    checkTime(phone) {
      for (let i = 0; i < this.allassignagent.length; i++) {
        if (this.allassignagent[i].usermno == phone) {
          // console.log(this.allassignagent[i], "vvvvvvvvvvvvvvvvvvvvvvvvv");
          let curdate = new Date();
          let timediff = Math.abs(
            curdate.getTime() -
              new Date(this.allassignagent[i].updatedAt).getTime()
          );
          let hours = Math.floor(timediff / (1000 * 60 * 60));
          // console.log(
          //   curdate.getTime() -
          //     new Date(this.allassignagent[i].updatedAt).getTime(),
          //   "kjhkhj",
          //   i,
          //   "jhfhgfh"
          // );
          if (this.allassignagent[i].isreply == false) {
            return new Date(timediff).toTimeString().slice(0, 8);
          } else {
            return "Assigned";
          }
        }
      }
      // console.log("falseeeee");
      return null;
      // var result=  this.allassignagent.filter((val) => {
      console.log(val, "valval");
      //  return val.usermno == phone
      // });
      // if(result.length>0){

      //   let curdate = new Date();
      //           let timediff = Math.abs(
      //             curdate.getTime() - new Date(result[0].updatedAt).getTime()
      //           );
      //           this.gethours = Math.floor(timediff / (1000 * 60 * 60));
      //             this.gethours=24-this.gethours
      //         console.log(this.gethours,"ppppppppppppppppppppppp")

      // }else{
      //     this.gethours="Not Assign"
      //   console.log("notr assign")

      // }
    },
    async sucsess(text) {
      this.$swal({
        text: "This chat is already assigned to this Agent",
        icon: "success",
        timer: 1500,
        confirmButtonColor: "#CD3197",
        confirmButtonText: "OK",
      });
    },
    async updateChatStatus(phone, status) {
      const payload = {
        number: phone,
        status: status,
      };
      try {
        let { data } = await this.$store.dispatch(
          "AgentRouting/updateChatStatus",
          payload
        );

        await this.assignStatuss();
        if (data.code == 200) {
          this.sucsess("Status Chang Successfully");
        }
      } catch (err) {
        console.log(err);
      }
    },
    checkCurrenttStatus(phone) {
      this.assignStatus.forEach((val) => {
        if (val.number == phone) {
          this.statuss = val.status;
        }
      });
    },
    CheckGetAssigned(phone) {
      for (let i in this.getassigned.result) {
        for (let numbers in this.getassigned.result[i].assignedNumber) {
          if (this.getassigned.result[i].assignedNumber[numbers] == phone) {
            return true;
          }
        }
      }
    },
    async GetAssigned() {
      try {
        const payload = {};
        await this.$store.dispatch("AgentRouting/GetAssigned", payload);
      } catch (Err) {
        console.log(Err);
      }
    },

    async assignStatuss() {
      var phoneno = [];
      this.contacts.map((val) => {
        phoneno.push(val.phone);
      });
      const payload = {
        number: phoneno,
      };
      try {
        await this.$store.dispatch("AgentRouting/assignStatus", payload);
      } catch (err) {
        console.log(err);
      }
    },
    async GetAllassignchat() {
      try {
        await this.$store.dispatch("AgentRouting/GetAllassignchat");
      } catch (err) {
        console.log(err);
      }
    },
  },
  async mounted() {
    // console.log(this.item.name, this.item.phone, "jygyuuyguyg");
    // await this.GetAssigned();
    // await this.assignStatuss();
    // await this.GetAllassignchat()
  },
};
</script>
<style>
.display-none {
  display: none;
}
</style>
